import * as React from "react";

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@replo/design-system/components/tabs/Tabs";
import { useAdminPanelActions } from "@v2/features/admin/adminPanelStore";
import { FeatureFlagsTab } from "@v2/features/admin/tabs/FeatureFlags";
import { MiscellaneousTab } from "@v2/features/admin/tabs/Miscellaneous";
import { OptionsTab } from "@v2/features/admin/tabs/Options";
import { FloatingPanel } from "@v2/features/debug/FloatingPanel";
import { useIsDebugMode } from "@v2/hooks/useIsDebugMode";

const AdminPanelInner = () => {
  const isDebugModeAllowed = useIsDebugMode();

  if (!isDebugModeAllowed) {
    return null;
  }

  return (
    <Tabs
      defaultValue="feature-flags"
      UNSAFE_className="min-h-0 flex-1 text-xs"
    >
      <TabsList variant="outline" size="sm">
        <TabsTrigger size="sm" value="feature-flags" UNSAFE_className="text-xs">
          Feature Flags
        </TabsTrigger>
        <TabsTrigger size="sm" value="options" UNSAFE_className="text-xs">
          Options
        </TabsTrigger>
        <TabsTrigger size="sm" value="miscellaneous" UNSAFE_className="text-xs">
          Miscellaneous
        </TabsTrigger>
      </TabsList>
      <TabsContent
        value="feature-flags"
        UNSAFE_className="flex min-h-0 flex-1 flex-col overflow-y-auto p-3"
      >
        <FeatureFlagsTab />
      </TabsContent>
      <TabsContent
        value="options"
        UNSAFE_className="flex min-h-0 flex-1 flex-col overflow-y-auto p-3"
      >
        <OptionsTab />
      </TabsContent>
      <TabsContent
        value="miscellaneous"
        UNSAFE_className="flex min-h-0 flex-1 flex-col gap-1 overflow-y-auto p-3"
      >
        <MiscellaneousTab />
      </TabsContent>
    </Tabs>
  );
};

export const AdminPanel = () => {
  const { close } = useAdminPanelActions();
  const [isMinimized, setIsMinimized] = React.useState(false);

  return (
    <FloatingPanel
      title="Admin Panel"
      storageKey="replo.debug.adminPanel"
      defaultSize={{ width: 700, height: 500 }}
      minSize={{ width: 400, height: 300 }}
      maxSize={{ width: 2000, height: 1200 }}
      onClose={close}
      onMinimize={() => setIsMinimized((prev) => !prev)}
      isMinimized={isMinimized}
    >
      <AdminPanelInner />
    </FloatingPanel>
  );
};
